import React, { useState, useEffect, useCallback, useContext, useRef } from "react";

import { Button } from "primereact/button";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { ContextMenu } from "primereact/contextmenu";
import { InputText } from "primereact/inputtext";
import { TabView, TabPanel } from "primereact/tabview";
import { Dropdown } from "primereact/dropdown";
import { Skeleton } from "primereact/skeleton";

import ComboBox from "../../../isp._comun/iu/componentes/widgets/ComboBox";
import GlobalContext from "../../../isp._comun/iu/contexto/GlobalContext";
import Dialogo from "../../../isp._comun/iu/_principal/componentes/layouts/Dialogo";
import { ModosOp } from "../../../isp._comun/iu/_principal/constantesIuPrin";
import { TipoDeDoc, TipoDeCliente } from "../../../isp.žapi.clientes/constantesApiClientes";
import EliminarVentana from "../../../isp._iu.start.principal/reductores/acciones/widgets/EliminarVentana";

// import * as AccionesFact from "../../reductores/acciones/AccionesTypeFact";
import * as Action from "../../reductores/acciones/dispatch/_ActionsDispatch";
import ActionClienteSet from "../../reductores/acciones/ActionClienteSet";
import ActionContactoClienteSet from "../../reductores/acciones/ActionContactoClienteSet";
// import ActionSetTipoCliente from "../../reductores/acciones/dispatch/SetTipoCliente";

import { EstadosDeCliente } from "./constantesIuLayoutClientes";
import * as ModelosDeCombos from "./ModeloDeCombos";
import Contacto from "../../reductores/Contacto";

const DialogoClienteLayout = ({
    ventana,
    estadoDCF,
    dispatchDCF,
    registrarClienteCommand,
    actualizarClienteCommand,
    buscarUnSoloClienteCommand,
}) => {
    const { dispatchPrincipal } = useContext(GlobalContext);
    const [activeIndex, setActiveIndex] = useState(0);
    const [banderaTabPersonasContacto, setBanderaTabPersonasContacto] = useState(false);

    const nombreContactoInput = useRef(null);
    const refMenuListaNombresContactos = useRef(null);
    // const refDomElement = useRef(null);
    const refDialogo = useRef(null);
    // const refTablaListaNombresContacto = useRef(null);
    // const isMounted = useRef(false);

    useEffect(
        () => {

            if (nombreContactoInput.current !== null) {
                nombreContactoInput.current.select();
                nombreContactoInput.current.focus();
                // console.log("Dentro de UseEffect: ", nomPersContactInput);
            }
            /* requestAnimationFrame(()=>{
                console.log(refMenuListaNombresContactos.current);

            }); */
            /* 
            function handler(event) {
                event.stopPropagation();
                event.cancelBubble = true;
                return false;
            }
            // listaNombresPersContact.current.element.onclick = handler;
            // listaNombresPersContact.current.element.onmousedown = handler;
            // listaNombresPersContact.current.element.onmouseup = handler;
        } */
        },
        [
            estadoDCF.flag.sensorSeleccionDeValorDeLista,
            // estadoDCF.personasContacto.flagControNombreSelected,
            // banderaTabPersonasContacto,
        ],
    );

    useEffect(() => {
        if (estadoDCF.flag.cargandoEntidad) {
            buscarUnSoloClienteCommand.ejecutar(estadoDCF.domain.screen.idCliente);
        }
        return () => {
            buscarUnSoloClienteCommand.cancelar();
        };
    }, [estadoDCF.flag.cargandoEntidad]);

    useEffect(() => {
        if (!estadoDCF.flag.procesandoComando) {
            return;
        }
        if (estadoDCF.flag.modoOperacion === ModosOp.CREAR) {
            registrarClienteCommand.ejecutar();
            return () => {
                registrarClienteCommand.cancelar();
            };
        }
        if (estadoDCF.flag.modoOperacion === ModosOp.MODIFICAR) {
            actualizarClienteCommand.ejecutar();
            return () => {
                actualizarClienteCommand.cancelar();
            };
        }
    }, [estadoDCF.flag.procesandoComando]);

    // const guardarClick = (eventoDom) => {
    //     console.log(eventoDom);
    //     dispatch(new EliminarVentana(ventana.id));
    //     //eventoDom.stopPropagation();
    // };

    const cancelarClick = (eventoSynDom) => {
        dispatchPrincipal(new EliminarVentana(ventana));
        // eventoSynDom.stopPropagation();
    };

    const header = {
        elementoReact: <p className="p-2 bg-gradient-to-r from-purple-100">Cliente a Facturar</p>,
        enProgreso: false,
        // enProgreso: estadoDCF.flag.procesandoComando,
    };

    const labelBotonAccion = (() => {
        if (estadoDCF.flag.modoOperacion === ModosOp.CREAR) return "Guardar";
        if (estadoDCF.flag.modoOperacion === ModosOp.OK) return "   OK    ";
        if (estadoDCF.flag.modoOperacion === ModosOp.MODIFICAR) return "Modificar";
    })();

    const footer = (
        <div>
            <Button
                label={labelBotonAccion}
                icon="pi pi-check"
                onClick={(eventoSynDom) => {
                    console.log("Right boton");
                    if (estadoDCF.flag.modoOperacion === ModosOp.CREAR) {
                        dispatchDCF(new Action.GuardarClienteAFacturar());
                        return;
                    }
                    if (estadoDCF.flag.modoOperacion === ModosOp.MODIFICAR) {
                        dispatchDCF(new Action.ActualizarClienteAFacturar());
                        return;
                    }
                    if (estadoDCF.flag.modoOperacion === ModosOp.OK) {
                        cancelarClick(eventoSynDom);
                        return;
                    }
                }}
                loading={estadoDCF.flag.procesandoComando}
                iconPos="left"
                className="whitespace-pre"
            />
            <Button
                label="Cancelar"
                icon="pi pi-times"
                onClick={(eventoDom) => cancelarClick(eventoDom)}
                disabled={estadoDCF.flag.procesandoComando}
                // className="w-32"
            />
        </div>
    );

    let bloqueTipoCliente;

    if (estadoDCF.domain.screen.tipoCliente === TipoDeCliente.DocId) {
        bloqueTipoCliente = (
            <>
                <div className="mr-10">
                    <div className="flex mb-0.5">
                        <div className="w-32 shrink-0">Tipo de Cliente : </div>
                        <div>
                            <ComboBox
                                seleccionable={estadoDCF.flag.tipoClienteSelec}
                                value={estadoDCF.domain.screen.tipoCliente}
                                options={ModelosDeCombos.tiposCliente}
                                onChange={(e) => {
                                    dispatchDCF(new Action.SetTipoCliente("tipoCliente", e.value));
                                }}
                                className="p-0 w-full rounded-none"
                                // panelClassName="p-0"
                                // panelStyle={{ padding: 0 }}
                                disabled={estadoDCF.flag.procesandoComando}
                            />
                            {/* <Dropdown
                                value={estadoDCF.domain.screen.tipoCliente}
                                options={ModelosDeCombos.tiposCliente}
                                onChange={(e) => {
                                    dispatchDCF(new ActionSetTipoCliente("tipoCliente", e.value));
                                }}
                                className="p-0 w-full rounded-none"
                                // panelClassName="p-0"
                                // panelStyle={{ padding: 0 }}
                                disabled={estadoDCF.flag.procesandoComando || !estadoDCF.flag.tipoClienteHab}
                            /> */}
                        </div>
                    </div>
                    <div className="flex mb-0.5">
                        <div className="w-32">Tipo de Doc. : </div>
                        <div>
                            <Dropdown
                                value={estadoDCF.domain.screen.tipoDoc}
                                options={ModelosDeCombos.tiposDoc}
                                onChange={(e) => {
                                    dispatchDCF(new ActionClienteSet("tipoDoc", e.target.value));
                                    // dispatchDCF(new Action.SetTipoDoc(e.value));
                                }}
                                // placeholder="Selecciona un Tipo"
                                className="p-0 w-full rounded-none"
                                // panelClassName="p-0"
                                // panelStyle={{ padding: 0 }}
                                disabled={estadoDCF.flag.procesandoComando}
                            />
                        </div>
                    </div>
                    <div className="flex">
                        <div className="w-32">N° de Doc. : </div>
                        <div>
                            <InputText
                                // id="in"
                                value={estadoDCF.domain.screen.nroDoc}
                                className="p-0 w-24 rounded-none block p-error"
                                onChange={(e) => {
                                    console.log("entro");
                                    dispatchDCF(
                                        new ActionClienteSet("nroDoc", e.target.value),
                                        // new Action.SetNroDoc(e.target.value)
                                    );
                                }}
                                maxLength={
                                    estadoDCF.domain.screen.tipoDoc === TipoDeDoc.DNI ? 8 : 9
                                }
                                disabled={estadoDCF.flag.procesandoComando}
                            />
                            <small
                                id=""
                                className={
                                    estadoDCF.error.nroDocBlanc ? "mb-1.5 block p-error" : "hidden"
                                }
                            >
                                Se requiere el Número de Documento.
                            </small>
                            <small
                                id=""
                                className={
                                    estadoDCF.error.nroDocMF ? "mb-1.5 block p-error" : "hidden"
                                }
                            >
                                El formato de N° de Doc. es incorrecto.
                            </small>
                        </div>
                    </div>
                </div>
                <div>
                    <div className="flex mb-0.5">
                        <div className="w-24 shrink-0">Apellidos : </div>
                        <div className="pl-0">
                            <InputText
                                id="in"
                                value={estadoDCF.domain.screen.apellidos}
                                className="p-0 w-full rounded-none"
                                onChange={(e) => {
                                    dispatchDCF(new ActionClienteSet("apellidos", e.target.value));
                                    console.log("evento apellidos: ", e);
                                }}
                                disabled={estadoDCF.flag.procesandoComando}
                            />
                            <small
                                id=""
                                className={
                                    estadoDCF.error.apellBlanc ? "mb-1.5 block p-error" : "hidden"
                                }
                            >
                                Se requiere Apellidos del Cliente.
                            </small>
                            <small
                                id=""
                                className={
                                    estadoDCF.error.apellMF ? "mb-1.5 block p-error" : "hidden"
                                }
                            >
                                El formato de los Apellidos es incorrecto.
                            </small>
                        </div>
                    </div>
                    <div className="flex mb-0.5">
                        <div className="w-24 shrink-0">Nombres : </div>
                        <div className="pl-0">
                            <InputText
                                id="in"
                                value={estadoDCF.domain.screen.nombres}
                                className="p-0 w-full rounded-none"
                                onChange={(e) =>
                                    dispatchDCF(
                                        new ActionClienteSet("nombres", e.target.value),
                                        // new Action.SetNombres(e.target.value)
                                    )
                                }
                                disabled={estadoDCF.flag.procesandoComando}
                            />
                            <small
                                id=""
                                className={
                                    estadoDCF.error.nomBlanc ? "mb-1.5 block p-error" : "hidden"
                                }
                            >
                                Se requiere Nombres del Cliente.
                            </small>
                            <small
                                id=""
                                className={
                                    estadoDCF.error.nomMF ? "mb-1.5 block p-error" : "hidden"
                                }
                            >
                                El formato de los Nombres es incorrecto.
                            </small>
                        </div>
                    </div>
                    <div className="flex">
                        <div className="w-24 shrink-0">Sexo : </div>
                        <div className="pl-0">
                            <Dropdown
                                value={estadoDCF.domain.screen.sexo}
                                options={ModelosDeCombos.tiposSexo}
                                onChange={
                                    (e) => dispatchDCF(new ActionClienteSet("sexo", e.target.value))
                                    // dispatchDCF(new Action.SetSexo(e.value))
                                }
                                placeholder="Seleccionar..."
                                className="p-0 w-full rounded-none"
                                // panelClassName="p-0"
                                // panelStyle={{ padding: 0 }}
                                disabled={estadoDCF.flag.procesandoComando}
                            />
                            <small
                                id=""
                                className={
                                    estadoDCF.error.sexoBlanc ? "mb-1.5 block p-error" : "hidden"
                                }
                            >
                                Se requiere elegir un Género.
                            </small>
                        </div>
                    </div>
                </div>
            </>
        );
    } else {
        // Cliente Tipo RUC
        bloqueTipoCliente = (
            <>
                <div className="mr-10">
                    <div className="flex mb-0.5">
                        <div className="w-32 shrink-0">Tipo de Cliente : </div>
                        <div>
                            <ComboBox
                                seleccionable={estadoDCF.flag.tipoClienteSelec}
                                value={estadoDCF.domain.screen.tipoCliente}
                                options={ModelosDeCombos.tiposCliente}
                                onChange={(e) => {
                                    // console.log(e);
                                    dispatchDCF(new Action.SetTipoCliente("tipoCliente", e.value));
                                }}
                                className="p-0 w-full rounded-none"
                                disabled={estadoDCF.flag.procesandoComando}
                            />
                        </div>
                    </div>
                    <div className="flex mb-0.5">
                        <div className="w-32 shrink-0">Razón Social : </div>
                        <div className="pl-0">
                            <InputText
                                value={estadoDCF.domain.screen.razonSocial}
                                className="p-0 w-72 rounded-none"
                                onChange={(e) =>
                                    dispatchDCF(
                                        new ActionClienteSet("razonSocial", e.target.value),
                                        /* new Action.SetRazonSocial(
                                            e.target.value
                                        ) */
                                    )
                                }
                                disabled={estadoDCF.flag.procesandoComando}
                            />
                            <small
                                id=""
                                className={
                                    estadoDCF.error.rsocialBlanc ? "mb-1.5 block p-error" : "hidden"
                                }
                            >
                                Se requiere una Razón Social.
                            </small>
                            <small
                                id=""
                                className={
                                    estadoDCF.error.rsocialMF ? "mb-1.5 block p-error" : "hidden"
                                }
                            >
                                El formato de Razón Social es incorrecto.
                            </small>
                        </div>
                    </div>
                    <div className="flex">
                        <div className="w-32 shrink-0">N° de RUC : </div>
                        <div className="pl-0">
                            <InputText
                                id="in2"
                                value={estadoDCF.domain.screen.ruc}
                                className="p-0 w-32 rounded-none"
                                onChange={(e) => {
                                    console.log("cargo");
                                    dispatchDCF(new ActionClienteSet("ruc", e.target.value));
                                }}
                                maxLength="11"
                                disabled={estadoDCF.flag.procesandoComando}
                            />
                            <small
                                id=""
                                className={
                                    estadoDCF.error.rucBlanc ? "mb-1.5 block p-error" : "hidden"
                                }
                            >
                                Se requiere un N° de RUC.
                            </small>
                            <small
                                id=""
                                className={
                                    estadoDCF.error.rucMF ? "mb-1.5 block p-error" : "hidden"
                                }
                            >
                                El formato del N° de RUC es incorrecto.
                            </small>
                        </div>
                    </div>
                </div>
            </>
        );
    }

    const bloqueTabs = (
        <TabView
            activeIndex={activeIndex}
            onTabChange={(e) => {
                setActiveIndex(e.index);
                if (e.index === 1) setBanderaTabPersonasContacto(!banderaTabPersonasContacto);
            }}
            className="mt-5"
        >
            <TabPanel header="General">
                <div className="flex mb-0.5 flex-wrap ">
                    <div className="w-36 shrink-0">Telf. Celular 1 : </div>
                    <div className="shrink-0">
                        <InputText
                            id="in"
                            value={estadoDCF.domain.screen.general.telcel1}
                            className="p-0 w-32 rounded-none"
                            onChange={(e) => {
                                dispatchDCF(
                                    new ActionClienteSet("general.telcel1", e.target.value),
                                    /* new Action.SetGeneralTelcel1(
                                    e.target.value
                                ) */
                                );
                            }}
                            disabled={estadoDCF.flag.procesandoComando}
                        />
                        <small
                            id=""
                            className={
                                estadoDCF.error.telcel1Blanc ? "mb-1.5 block p-error" : "hidden"
                            }
                        >
                            Se requiere el Número del Primer Celular.
                        </small>
                        <small
                            id=""
                            className={
                                estadoDCF.error.telcel1MF ? "mb-1.5 block p-error" : "hidden"
                            }
                        >
                            El formato del Número de Teléfono es incorrecto.
                        </small>
                    </div>
                </div>
                <div className="flex mb-0.5 flex-wrap">
                    <div className="w-36 shrink-0">Telf. Celular 2 : </div>
                    <div className="shrink-0">
                        <InputText
                            id="in"
                            value={estadoDCF.domain.screen.general.telcel2}
                            className="p-0 w-32 rounded-none"
                            onChange={(e) =>
                                dispatchDCF(
                                    new ActionClienteSet("general.telcel2", e.target.value),
                                    /* new Action.SetGeneralTelcel2(
                                    e.target.value
                                ) */
                                )
                            }
                            disabled={estadoDCF.flag.procesandoComando}
                        />
                        <small
                            id=""
                            className={
                                estadoDCF.error.telcel2MF ? "mb-1.5 block p-error" : "hidden"
                            }
                        >
                            El formato del Número de Teléfono es incorrecto.
                        </small>
                    </div>
                </div>
                <div className="flex mb-0.5 flex-wrap">
                    <div className="w-36 shrink-0">Telf. Fijo : </div>
                    <div className="shrink-0">
                        <InputText
                            id="in"
                            value={estadoDCF.domain.screen.general.telfijo}
                            className="p-0 w-32 rounded-none"
                            onChange={(e) =>
                                dispatchDCF(
                                    new ActionClienteSet("general.telfijo", e.target.value),
                                    /* new Action.SetGeneralTelfijo(
                                    e.target.value
                                ) */
                                )
                            }
                            disabled={estadoDCF.flag.procesandoComando}
                        />
                        <small
                            id=""
                            className={
                                estadoDCF.error.telfijoMF ? "mb-1.5 block p-error" : "hidden"
                            }
                        >
                            El formato del Número de Teléfono es incorrecto.
                        </small>
                    </div>
                </div>
                <div className="flex mb-0.5  flex-wrap">
                    <div className="w-36 shrink-0">Email : </div>
                    <div className="shrink-0">
                        <InputText
                            id="in"
                            value={estadoDCF.domain.screen.general.email}
                            className="p-0 w-full rounded-none"
                            onChange={(e) =>
                                dispatchDCF(
                                    new ActionClienteSet("general.email", e.target.value),
                                    /* new Action.SetGeneralEmail(
                                    e.target.value
                                ) */
                                )
                            }
                            // disabled={true}
                        />
                        <small
                            id=""
                            className={estadoDCF.error.emailMF ? "mb-1.5 block p-error" : "hidden"}
                        >
                            El formato del e-mail es incorrecto.
                        </small>
                    </div>
                </div>
                <div className="flex mb-0.5 flex-wrap">
                    <div className="w-36 shrink-0">Sitio Web o Blog : </div>
                    <div className="shrink-0">
                        <InputText
                            id="in"
                            value={estadoDCF.domain.screen.general.sitioWeb}
                            className="p-0 w-full rounded-none"
                            onChange={(e) =>
                                dispatchDCF(
                                    new ActionClienteSet("general.sitioWeb", e.target.value),
                                    /* new Action.SetGeneralSitioBlog(
                                    e.target.value
                                ) */
                                )
                            }
                            // disabled={true}
                        />
                        <small
                            id=""
                            className={
                                estadoDCF.error.sitioWebMF ? "mb-1.5 block p-error" : "hidden"
                            }
                        >
                            El formato del Sitio Web es incorrecto.
                        </small>
                    </div>
                </div>
            </TabPanel>

            {/* <TabPanel header="Cobranza">
            <div className="flex mb-0.5">
                <div className="w-48 shrink-0">Modo de Cobro : </div>
                <div className="pl-0 shrink-0">
                    <Dropdown
                        value={estadoDCF.domain.screen.cobranza.modoCobro}
                        options={ModelosDeCombos.modosCobro}
                        onChange={(e) =>
                            dispatchDCF(new AccionesFact.SetCobranzaModoCobro(e.value))
                        }
                        placeholder="Seleccionar..."
                        className="p-0 w-full rounded-none"
                        panelClassName="p-0"
                        disabled={true}
                    />
                </div>
            </div>
            <div className="flex mb-0.5">
                <div className="w-48 shrink-0">Tipo de Comprobante : </div>
                <div className="pl-0 shrink-0">
                    <Dropdown
                        value={estadoDCF.domain.screen.cobranza.tipoComprobante}
                        options={ModelosDeCombos.tiposComprobantes}
                        onChange={(e) =>
                            dispatchDCF(
                                new AccionesFact.SetCobranzaTipoComprobante(e.value)
                            )
                        }
                        placeholder="Seleccionar..."
                        className="p-0 w-full rounded-none"
                        panelClassName="p-0"
                        // disabled={
                        //     !estadoDCF.cobranza.controlTipoComprobante
                        // }
                        disabled={true}
                    />
                </div>
            </div>
            <div className="flex">
                <div className="w-48 shrink-0">Ciclo de Facturación : </div>
                <div className="pl-0">
                    <Dropdown
                        value={estadoDCF.domain.screen.cobranza.cicloFact}
                        options={ModelosDeCombos.ciclosFact}
                        onChange={(e) =>
                            dispatchDCF(new AccionesFact.SetCobranzaCicloFact(e.value))
                        }
                        placeholder="Seleccionar..."
                        className="p-0 w-full rounded-none"
                        panelClassName="p-0"
                        // disabled={!estadoDCF.cobranza.controlCicloFact}
                        disabled={true}
                    />
                </div>
            </div>
        </TabPanel> */}

            <TabPanel
                // ref={refTabPersonasContactos}
                header="Personas de Contacto"
                contentClassName="flex justify-between flex-wrap"
            >
                <div className="pr-6 w-72">
                    <ContextMenu
                        ref={refMenuListaNombresContactos}
                        model={[
                            {
                                label: "Eliminar Contacto",
                                command: () => {
                                    // dispatchDCF(new Action.EliminarContacto(e.index));
                                    dispatchDCF(new Action.EliminarContacto());
                                    /* dispatchDCF(
                                        new AccionesFact.EliminarContactoAct(
                                            estadoDCF.domain.screen.contactos.valorListaNombres,
                                        ),
                                    ); */
                                    //console.log("eliminar contacto");
                                },
                            },
                        ]}
                        //popup
                        // baseZIndex={10}
                        // style={{ top: "-142px", left: "-590px" }}
                        // style={{ marginTop: "-142px", marginLeft: "-590px" }}
                        // style={{ marginTop: "4px", marginLeft: "-3px" }}
                        // appendTo={refDomElement.current}
                        // appendTo={refDialogo.current}
                        /* appendTo={(el)=>{
                            return refDialogo.current=el
                        }} */
                        // appendTo={refTablaListaNombresContacto.current}
                        appendTo={"self"}
                        // global={false}
                        className={"w-fit"}
                        // disabled={false}
                    />
                    <DataTable
                        // ref={refTablaListaNombresContacto}
                        dataKey={"sec"}
                        value={estadoDCF.domain.screen.contactos.listaNombres}
                        contextMenuSelection={estadoDCF.domain.screen.contactos.valorListaNombres}
                        onContextMenuSelectionChange={(e) => {
                            // console.log("cambiar seleccion", e.value);
                            // dispatchDCF(new Action.SetContactoValorListaNombres(e.value));
                            // menuListaNombresContactos.current.hide(e.originalEvent);
                            //console.log("context menu selecction", e);
                            /* dispatchDCF(
                                new AccionesFact.SetPersonaContactoValorListaNombresOperaciones(
                                    e.value,
                                ),
                            ); */

                            dispatchDCF(new Action.SeleccionarContacto(e.value));

                            /* if(e.data.nombre!==Contacto.labelDefinirNuevoContacto){
                                menuListaNombresContactos.current.show(e.originalEvent);
                                // menuListaNombresContactos.current.show(e.originalEvent);
                            } */
                            // e.originalEvent.stopPropagation();
                        }}
                        onContextMenu={(e) => {
                            // console.log("mostrar menu");
                            // console.log("refDialogo: ",refDialogo.current);

                            // dispatchDCF(new Action.SetContactoValorListaNombres(e.data));
                            const listaNombres = estadoDCF.domain.screen.contactos.listaNombres;
                            const ultimoValorDeListaNombres = listaNombres[listaNombres.length-1];
                            if (e.data.sec !==ultimoValorDeListaNombres.sec) {
                                // e.originalEvent.clientX=0;
                                // e.originalEvent.screenX=0;
                                // e.originalEvent.pageX = 0;
                                // e.originalEvent.pageX = 0;
                                // const rect = refDialogo.current.dialogRef.current.getBoundingClientRect();
                                // // e.originalEvent.pageX = e.originalEvent.clientX-300;
                                // // e.originalEvent.pageY = e.originalEvent.clientY;
                                // console.log("x ",e.originalEvent.clientX);
                                // console.log("y ",e.originalEvent.clientY);
                                // console.log("screen x ",e.originalEvent.screenX);
                                // console.log("screen y ",e.originalEvent.screenY);
                                e.originalEvent.pageX =
                                    e.originalEvent.pageX - refDialogo.current.xDialogo;
                                e.originalEvent.pageY =
                                    e.originalEvent.pageY - refDialogo.current.yDialogo;
                                // console.log(refDialogo.current);
                                refMenuListaNombresContactos.current.show(e.originalEvent);
                                // refMenuListaNombresContactos.current.props.style={top:0,left:0};
                                // menuListaNombresContactos.current.show(e.originalEvent);
                            } else {
                                refMenuListaNombresContactos.current.hide(e.originalEvent);
                            }
                            // e.originalEvent.stopPropagation();
                            //cm.current.show(e)
                            requestAnimationFrame(() => {
                                console.log(refMenuListaNombresContactos.current);
                            });
                        }}
                        responsiveLayout="scroll"
                        selectionMode="single"
                        selection={estadoDCF.domain.screen.contactos.valorListaNombres}
                        onRowClick={(e) => {
                            console.log("onRowClick", e.data);
                            // console.log("change selecction", e);
                            dispatchDCF(new Action.SeleccionarContacto(e.data));
                            refMenuListaNombresContactos.current.hide(e.originalEvent);
                            // console.log("change selecction", e);
                        }}
                        onSelectionChange={(e) => {
                            console.log("onSelectionChange: ", e);
                            // console.log("change selecction", e);
                            // dispatchDCF(new Action.SeleccionarContacto(e.data));
                            // refMenuListaNombresContactos.current.hide(e.originalEvent);
                            // console.log("change selecction", e);
                        }}
                        
                        onRowSelect={(e) => {
                            console.log("onRowSelect", e.data);
                            // console.log("change selecction", e);
                            // dispatchDCF(new Action.SeleccionarContacto(e.data));
                            // refMenuListaNombresContactos.current.hide(e.originalEvent);
                            // console.log("change selecction", e);
                        }}
                        onRowUnselect={(e) => {
                            console.log("onRowUnselect", e.data);
                            // console.log("change selecction", e);
                            // dispatchDCF(new Action.SeleccionarContacto(e.data));
                            // refMenuListaNombresContactos.current.hide(e.originalEvent);
                            // console.log("change selecction", e);
                        }}
                        tableClassName="p-0 w-full rounded-none listaSinHead border"
                        tableStyle={{ height: "10.4rem" }}
                        header={null}
                        scrollable
                        scrollHeight="10.4rem"
                        // isDataSelectable={() => false}
                        // loading={true}
                    >
                        <Column
                            field="nombre"
                            header={null}
                            headerStyle={{ padding: 0, height: 0 }}
                            // style={{ padding: "0rem" }}
                            // className="p-0"
                            // bodyStyle={{ padding: "0rem" }}
                            bodyClassName="p-0 mb-0.5"
                        ></Column>
                    </DataTable>
                </div>

                <div id="atributos">
                    <div className="flex flex-wrap mb-0.5">
                        <div className="w-32">Nombre : </div>
                        <div className="pl-0">
                            <InputText
                                ref={nombreContactoInput}
                                // value={estadoDCF.domain.screen.contactos.atridbutos.nombre}
                                value={estadoDCF.domain.screen.contactos.atributos.nombre}
                                className="p-0 w-64 rounded-none"
                                onChange={(e) => {
                                    dispatchDCF(
                                        new ActionContactoClienteSet("nombre", e.target.value),
                                        /* new AccionesFact.SetPersonaContactoAtributosNombre(
                                        e.target.value
                                    ) */
                                    );
                                    // console.log("change");
                                }}
                                onBlur={(e) => {
                                    dispatchDCF(new Action.SalirDeNombreDeContacto());
                                    //console.log("nombre blur");
                                }}
                                disabled={false}
                            />
                        </div>
                    </div>
                    <div className="flex flex-wrap mb-0.5">
                        <div className="w-32">Rol : </div>
                        <div className="pl-0">
                            <InputText
                                id="in"
                                value={estadoDCF.domain.screen.contactos.atributos.rol}
                                className="p-0 w-full rounded-none"
                                onChange={
                                    (e) =>
                                        dispatchDCF(
                                            new ActionContactoClienteSet("rol", e.target.value),
                                        )
                                    /* dispatchDCF(
                                        new AccionesFact.SetPersonaContactoAtributosRol(
                                            e.target.value,
                                        ),
                                    ) */
                                }
                                /* onBlur={(e) => {
                                    // console.log("blur");
                                    dispatchDCF(new AccionesFact.SetPersonasContactoActRol());
                                }} */
                                disabled={false}
                            />
                        </div>
                    </div>
                    <div className="flex flex-wrap mb-0.5">
                        <div className="w-32">Telf. Celular 1 : </div>
                        <div className="pl-0">
                            <InputText
                                id="in"
                                value={estadoDCF.domain.screen.contactos.atributos.telcel1}
                                className="p-0 w-full rounded-none"
                                onChange={(e) =>
                                    dispatchDCF(
                                        //
                                        new ActionContactoClienteSet("telcel1", e.target.value),
                                    )
                                }
                                /* onBlur={(e) => {
                                    // console.log("blur");
                                    dispatchDCF(new AccionesFact.SetPersonasContactoActTelcel1());
                                }} */
                                disabled={false}
                            />
                        </div>
                    </div>
                    <div className="flex flex-wrap mb-0.5">
                        <div className="w-32">Telf. Celular 2 : </div>
                        <div className="pl-0">
                            <InputText
                                id="in"
                                value={estadoDCF.domain.screen.contactos.atributos.telcel2}
                                className="p-0 w-full rounded-none"
                                onChange={
                                    (e) =>
                                        dispatchDCF(
                                            new ActionContactoClienteSet("telcel2", e.target.value),
                                        )
                                    /* dispatchDCF(
                                        new AccionesFact.SetPersonaContactoAtributosTelcel2(
                                            e.target.value,
                                        ),
                                    ) */
                                }
                                /* onBlur={(e) => {
                                    // console.log("blur");
                                    dispatchDCF(new AccionesFact.SetPersonasContactoActTelcel2());
                                }} */
                                disabled={false}
                            />
                        </div>
                    </div>
                    <div className="flex flex-wrap mb-0.5">
                        <div className="w-32">Telf. Fijo : </div>
                        <div className="pl-0">
                            <InputText
                                id="in"
                                value={estadoDCF.domain.screen.contactos.atributos.telfijo}
                                className="p-0 w-full rounded-none"
                                onChange={
                                    (e) =>
                                        dispatchDCF(
                                            new ActionContactoClienteSet("telfijo", e.target.value),
                                        )
                                    /* dispatchDCF(
                                        new AccionesFact.SetPersonaContactoAtributosTelfijo(
                                            e.target.value,
                                        ),
                                    ) */
                                }
                                /* onBlur={(e) => {
                                    // console.log("blur");
                                    dispatchDCF(new AccionesFact.SetPersonasContactoActTelfijo());
                                }} */
                                disabled={false}
                            />
                        </div>
                    </div>
                    <div className="flex flex-wrap mb-0.5">
                        <div className="w-32">E-mail : </div>
                        <div className="pl-0">
                            <InputText
                                id="in"
                                value={estadoDCF.domain.screen.contactos.atributos.email}
                                className="p-0 w-full rounded-none"
                                onChange={
                                    (e) =>
                                        dispatchDCF(
                                            new ActionContactoClienteSet("email", e.target.value),
                                        )
                                    /* dispatchDCF(
                                        new AccionesFact.SetPersonaContactoAtributosEmail(
                                            e.target.value,
                                        ),
                                    ) */
                                }
                                /* onBlur={(e) => {
                                    // console.log("blur");
                                    dispatchDCF(new AccionesFact.SetPersonasContactoActEmail());
                                }} */
                                disabled={false}
                            />
                        </div>
                    </div>
                </div>
            </TabPanel>
        </TabView>
    );

    let bloqueAtributos = null;

    if (estadoDCF.flag.cargandoEntidad) {
        bloqueAtributos = (
            <>
                <div className="flex flex-row justify-between">
                    <Skeleton width="45%" height="6rem"></Skeleton>
                    <Skeleton width="40%" height="6rem"></Skeleton>
                </div>
                <br></br>
                <br></br>
                <div>
                    <Skeleton width="100%" height="10rem"></Skeleton>
                </div>
            </>
        );
    } else {
        bloqueAtributos = (
            <>
                <div className="flex justify-between flex-wrap">{bloqueTipoCliente}</div>
                {bloqueTabs}
            </>
        );
    }

    return (
        <Dialogo
            ref={refDialogo}
            ventana={ventana}
            cabecera={header}
            modal={estadoDCF.flag.modal}
            posicionZ={ventana.posicionZ}
            pie={footer}
            estilo={{ width: "48rem", minHeight: "70vh", top: "15vh", margin: "0" }}
        >
            <div className="flex justify-between">
                <div>
                    <div className="flex">
                        <div className="w-40">Id. de Cliente : </div>
                        <div>{estadoDCF.domain.screen.idCliente}</div>
                    </div>
                    <div className="flex">
                        <div className="w-40"></div>
                        {/* <div className="w-40">Código de Cliente : </div> }*/}
                        {/*<div>
                            {/* <InputText
                                id="in"
                                value={estadoDCF.domain.screen.codigoCliente}
                                className="p-0 w-24 rounded-none"
                                onChange={(e) => {
                                    dispatchDCF(
                                        new Action.SetCodigoCliente(
                                            e.target.value
                                        )
                                        // new AccionesFact.SetCodigoCliente(e.target.value)
                                    );
                                }}
                                maxLength="7"
                                disabled={estadoDCF.flag.procesandoComando}
                            />
                            <small
                                id=""
                                className={
                                    estadoDCF.error.codClientMF
                                        ? "mb-1.5 block p-error"
                                        : "hidden"
                                }
                            >
                                El formato del Cod. de Cliente es incorrecto.
                            </small> }/*
                        </div>*/}
                    </div>
                </div>
                <div>
                    <div className="flex">
                        <div className="w-40 shrink-0">Fecha de Registro : </div>
                        <div>{estadoDCF.domain.screen.fechaReg}</div>
                    </div>
                    <div className="flex">
                        <div className="w-40">Estado : </div>
                        <div>{EstadosDeCliente[estadoDCF.domain.screen.estado]}</div>
                    </div>
                </div>
            </div>

            <hr className="my-3"></hr>

            {bloqueAtributos}
            {/* <div className="flex justify-between flex-wrap">{bloqueTipoCliente}</div> }*/}

            {/* {bloqueTabs}  */}
        </Dialogo>
    );
};

export default DialogoClienteLayout;
